const DEFAULT_SERVICE_THEME = 'blue'

const THEME_DEFINITIONS = {
  slate: {
    backgroundGradientClass: 'from-slate-50 via-white to-slate-50',
    textGradientClass: 'from-[#94A3B8] via-[#475569] to-[#1E293B]',
    primaryTextClass: 'text-slate-500',
    stops: ['#94A3B8', '#475569', '#1E293B'],
  },
  gray: {
    backgroundGradientClass: 'from-gray-50 via-white to-gray-50',
    textGradientClass: 'from-[#9CA3AF] via-[#4B5563] to-[#1F2937]',
    primaryTextClass: 'text-gray-500',
    stops: ['#9CA3AF', '#4B5563', '#1F2937'],
  },
  zinc: {
    backgroundGradientClass: 'from-zinc-50 via-white to-zinc-50',
    textGradientClass: 'from-[#A1A1AA] via-[#52525B] to-[#27272A]',
    primaryTextClass: 'text-zinc-500',
    stops: ['#A1A1AA', '#52525B', '#27272A'],
  },
  neutral: {
    backgroundGradientClass: 'from-neutral-50 via-white to-neutral-50',
    textGradientClass: 'from-[#A3A3A3] via-[#525252] to-[#262626]',
    primaryTextClass: 'text-neutral-500',
    stops: ['#A3A3A3', '#525252', '#262626'],
  },
  stone: {
    backgroundGradientClass: 'from-stone-50 via-white to-stone-50',
    textGradientClass: 'from-[#A8A29E] via-[#57534E] to-[#292524]',
    primaryTextClass: 'text-stone-500',
    stops: ['#A8A29E', '#57534E', '#292524'],
  },
  red: {
    backgroundGradientClass: 'from-red-50 via-white to-red-50',
    textGradientClass: 'from-[#F87171] via-[#EF4444] to-[#B91C1C]',
    primaryTextClass: 'text-red-500',
    stops: ['#F87171', '#EF4444', '#B91C1C'],
  },
  orange: {
    backgroundGradientClass: 'from-orange-50 via-white to-orange-50',
    textGradientClass: 'from-vrose via-vred to-vorange',
    primaryTextClass: 'text-vrose',
    stops: ['#FB155F', '#FC3B09', '#FB8415'],
  },
  amber: {
    backgroundGradientClass: 'from-amber-50 via-white to-amber-50',
    textGradientClass: 'from-[#FBBF24] via-[#D97706] to-[#92400E]',
    primaryTextClass: 'text-amber-500',
    stops: ['#FBBF24', '#D97706', '#92400E'],
  },
  yellow: {
    backgroundGradientClass: 'from-yellow-50 via-white to-yellow-50',
    textGradientClass: 'from-[#FDE047] via-[#FACC15] to-[#CA8A04]',
    primaryTextClass: 'text-yellow-500',
    stops: ['#FDE047', '#FACC15', '#CA8A04'],
  },
  lime: {
    backgroundGradientClass: 'from-lime-50 via-white to-lime-50',
    textGradientClass: 'from-[#A3E635] via-[#65A30D] to-[#3F6212]',
    primaryTextClass: 'text-lime-500',
    stops: ['#A3E635', '#65A30D', '#3F6212'],
  },
  green: {
    backgroundGradientClass: 'from-emerald-50 via-white to-lime-50',
    textGradientClass: 'from-shopify2 to-shopify3',
    buttonGradientClass: 'from-shopify2 to-shopify3',
    primaryTextClass: 'text-shopify2',
    stops: ['#004D40', '#5E8E3E', '#94BE46'],
  },
  emerald: {
    backgroundGradientClass: 'from-emerald-50 via-white to-emerald-50',
    textGradientClass: 'from-[#34D399] via-[#10B981] to-[#065F46]',
    primaryTextClass: 'text-emerald-500',
    stops: ['#34D399', '#10B981', '#065F46'],
  },
  teal: {
    backgroundGradientClass: 'from-teal-50 via-white to-teal-50',
    textGradientClass: 'from-[#2DD4BF] via-[#14B8A6] to-[#0F766E]',
    primaryTextClass: 'text-teal-500',
    stops: ['#2DD4BF', '#14B8A6', '#0F766E'],
  },
  cyan: {
    backgroundGradientClass: 'from-cyan-50 via-white to-cyan-50',
    textGradientClass: 'from-[#22D3EE] via-[#06B6D4] to-[#0E7490]',
    primaryTextClass: 'text-cyan-500',
    stops: ['#22D3EE', '#06B6D4', '#0E7490'],
  },
  sky: {
    backgroundGradientClass: 'from-sky-50 via-white to-sky-50',
    textGradientClass: 'from-[#38BDF8] via-[#0284C7] to-[#075985]',
    primaryTextClass: 'text-sky-500',
    stops: ['#38BDF8', '#0284C7', '#075985'],
  },
  blue: {
    backgroundGradientClass: 'from-blue-50 via-white to-blue-50',
    textGradientClass: 'from-vblue1 via-vblue2 to-vcyan1',
    primaryTextClass: 'text-blue-500',
    stops: ['#0629C8', '#0648E2', '#049FF2'],
    meshStopsOverride: ['#049FF2', '#049FF2', '#049FF2'],
  },
  indigo: {
    backgroundGradientClass: 'from-indigo-50 via-white to-indigo-50',
    textGradientClass: 'from-[#818CF8] via-[#6366F1] to-[#4338CA]',
    primaryTextClass: 'text-indigo-500',
    stops: ['#818CF8', '#6366F1', '#4338CA'],
  },
  violet: {
    backgroundGradientClass: 'from-violet-50 via-white to-violet-50',
    textGradientClass: 'from-[#A78BFA] via-[#8B5CF6] to-[#4C1D95]',
    primaryTextClass: 'text-violet-500',
    stops: ['#A78BFA', '#8B5CF6', '#4C1D95'],
  },
  purple: {
    backgroundGradientClass: 'from-purple-50 via-white to-purple-50',
    textGradientClass: 'from-[#C084FC] via-[#A855F7] to-[#6B21A8]',
    buttonGradientClass: 'from-violet-500 via-indigo-500 to-blue-500',
    primaryTextClass: 'text-purple-500',
    stops: ['#C084FC', '#A855F7', '#6B21A8'],
  },
  fuchsia: {
    backgroundGradientClass: 'from-fuchsia-50 via-white to-fuchsia-50',
    textGradientClass: 'from-[#E879F9] via-[#D946EF] to-[#86198F]',
    primaryTextClass: 'text-fuchsia-500',
    stops: ['#E879F9', '#D946EF', '#86198F'],
  },
  pink: {
    backgroundGradientClass: 'from-pink-50 via-white to-pink-50',
    textGradientClass: 'from-[#F472B6] via-[#EC4899] to-[#BE185D]',
    primaryTextClass: 'text-pink-500',
    stops: ['#F472B6', '#EC4899', '#BE185D'],
  },
  rose: {
    backgroundGradientClass: 'from-rose-50 via-white to-rose-50',
    textGradientClass: 'from-[#FB7185] via-[#F43F5E] to-[#BE123C]',
    primaryTextClass: 'text-rose-500',
    stops: ['#FB7185', '#F43F5E', '#BE123C'],
  },
}

const BUTTON_GRADIENT_CLASS_MAP = {
  white: 'from-white to-white [&_span]:text-black',
  ghost: '[&_span]:text-black',
}

function hexToRgba(hex, alpha) {
  const value = hex.replace('#', '')
  const normalized = value.length === 3
    ? value
        .split('')
        .map((char) => char + char)
        .join('')
    : value

  const r = parseInt(normalized.slice(0, 2), 16)
  const g = parseInt(normalized.slice(2, 4), 16)
  const b = parseInt(normalized.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

function buildMeshStops(stops) {
  const sizes = [0.4, 0.38, 0.42]
  const alphas = [0.15, 0.18, 0.13]

  return stops.map((stop, index) => ({
    color: hexToRgba(stop, alphas[index] || 0.15),
    size: sizes[index] || 0.4,
  }))
}

export const SERVICE_THEMES = Object.fromEntries(
  Object.entries(THEME_DEFINITIONS).map(([key, theme]) => [
    key,
    {
      key,
      ...theme,
      buttonGradientClass: theme.buttonGradientClass || theme.textGradientClass,
      logoStops: {
        from: theme.stops[0],
        mid: theme.stops[1],
        to: theme.stops[2],
      },
      meshStops: buildMeshStops(theme.meshStopsOverride || theme.stops),
    },
  ]),
)

export function getServiceThemeKey(theme) {
  return SERVICE_THEMES[theme] ? theme : DEFAULT_SERVICE_THEME
}

export function getServiceTheme(theme) {
  return SERVICE_THEMES[getServiceThemeKey(theme)]
}

export function getRouteServiceTheme(pathname = '') {
  if (pathname === '/shopify') return 'blue'
  if (pathname.startsWith('/paid-search')) return 'orange'
  return DEFAULT_SERVICE_THEME
}

export function getButtonGradientClass(color) {
  if (BUTTON_GRADIENT_CLASS_MAP[color]) return BUTTON_GRADIENT_CLASS_MAP[color]

  return getServiceTheme(color).buttonGradientClass
}

export { DEFAULT_SERVICE_THEME }
